import { render } from "./TravelPass.vue?vue&type=template&id=95630472&lang=pug"
import script from "./TravelPass.vue?vue&type=script&lang=ts"
export * from "./TravelPass.vue?vue&type=script&lang=ts"

import "./TravelPass.vue?vue&type=style&index=0&id=95630472&lang=scss"
script.render = render

export default script